export function getFirst3Words(text: string) {
  const splitted = text.split(" ");

  if (splitted.length <= 3) {
    return text;
  }

  return `${splitted[0]} ${splitted[1]} ${splitted[2]}...`;
}
